import { useEphattaQuery } from "../../.."
import { useAdvertBookingService } from "./useAdvertBookingService"

export const useAdvertBooking = (id: number, suspense: boolean = false) => {
    const service = useAdvertBookingService()
    return useEphattaQuery(["Adverts.Booking.GetBookingById", id], () => service.getBookingById(id), { suspense, enabled:!!id })
}